import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Paper,
  Typography,
  Tooltip
} from '@mui/material';
import {
  Close as CloseIcon,
  Minimize as MinimizeIcon,
  Maximize as MaximizeIcon,
  LocalShipping as LocalShippingIcon
} from '@mui/icons-material';
import ModalCreateShipment from '../../pages/shipping/modalcreatshipment';
import { STORAGE_KEY } from '../../hooks/useModalShipmentState';

interface MinimizableShipmentModalProps {
  open: boolean;
  onClose: () => void;
}

export default function MinimizableShipmentModal({ open, onClose }: MinimizableShipmentModalProps) {
  const [isMinimized, setIsMinimized] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(open);
  const [mountShipment, setMountShipment] = useState(true);

  useEffect(() => {
    if (open) {
      setIsDialogOpen(true);
      setMountShipment(true);
    }
  }, [open]);

  const handleMinimize = () => {
    setIsMinimized(true);
    setIsDialogOpen(false);
  };

  const handleMaximize = () => {
    setIsMinimized(false);
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    setIsMinimized(false);
    setIsDialogOpen(false);
    setMountShipment(false);
    sessionStorage.removeItem(STORAGE_KEY); // Limpa o storage ao fechar completamente
    onClose();
  };

  const handleDialogClose = () => {
    handleMinimize(); // Minimiza ao invés de fechar quando clica fora
  };

  return (
    <>
      {/* Modal minimizada */}
      {isMinimized && (
        <Paper
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1300,
            padding: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: 'rgb(10,25,47)',
            color: 'white',
            cursor: 'pointer'
          }}
          onClick={handleMaximize}
        >
          <LocalShippingIcon />
          <Typography variant="body2">Criar Envio</Typography>
          <IconButton size="small" sx={{ color: 'white' }}>
            <MaximizeIcon />
          </IconButton>
        </Paper>
      )}

      {/* Modal principal */}
      <Dialog
        open={isDialogOpen}
        onClose={handleDialogClose} // Minimiza ao invés de fechar quando clica fora
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: '80vh',
            maxHeight: '90vh'
          }
        }}
      >
        <Box sx={{ 
          position: 'absolute', 
          right: 8, 
          top: 8, 
          zIndex: 1,
          display: 'flex',
          gap: 1
        }}>
          <Tooltip title="Minimizar">
            <IconButton onClick={handleMinimize} size="small">
              <MinimizeIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Fechar">
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Box>
        
        <DialogContent>
          {/* Mantém o componente montado até que a modal seja fechada completamente */}
          {mountShipment && <ModalCreateShipment onClose={handleClose} />}
        </DialogContent>
      </Dialog>
    </>
  );
}
